import { render, staticRenderFns } from "./UserEditPasswordModal.vue?vue&type=template&id=67f6dbda&scoped=true&"
import script from "./UserEditPasswordModal.vue?vue&type=script&lang=js&"
export * from "./UserEditPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6dbda",
  null
  
)

export default component.exports